import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../../Images/loog.png';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className='px-4 py-5 bg-white mx-auto sm:max-w-full md:max-w-full lg:max-w-screen md:px-24 lg:px-14 sticky top-0 z-50 header-shadow'>
      <div className='relative flex items-center justify-between'>
        <Link
          to='/'
          aria-label='iTesser-act'
          title=' iTesser-act'
          className='inline-flex items-center'
        >
          <img className='w-60' src={logo} alt='logo' />
        </Link>
        <ul className='flex items-center hidden space-x-8 lg:flex'>
          <li>
            <Link
              to='/'
              aria-label='Home'
              title='Home'
              className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                isActive('/')
                  ? 'primary-color font-bold'
                  : 'text-gray-700 hover:primary-color'
              }`}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to='/about'
              aria-label='About Us'
              title='About Us'
              className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                isActive('/about')
                  ? 'primary-color font-bold'
                  : 'text-gray-700 hover:primary-color'
              }`}
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              to='/courses'
              aria-label='Courses'
              title='Courses'
              className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                isActive('/courses')
                  ? 'primary-color'
                  : 'text-gray-700 hover:primary-color'
              }`}
            >
              Courses
            </Link>
          </li>

          <li>
            <Link
              to='/gallery'
              aria-label='Our Gallery'
              title='Our Gallery'
              className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                isActive('/gallery')
                  ? 'primary-color'
                  : 'text-gray-700 hover:primary-color'
              }`}
            >
              Our Gallery
            </Link>
          </li>

          <li>
            <Link
              to='/team'
              aria-label='Our Team'
              title='Our Team'
              className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                isActive('/team')
                  ? 'primary-color'
                  : 'text-gray-700 hover:primary-color'
              }`}
            >
              Our Team
            </Link>
          </li>
          <li>
            <Link
              to='/admission'
              aria-label='Admission'
              title='Admission'
              className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                isActive('/admission')
                  ? 'primary-color'
                  : 'text-gray-700 hover:primary-color'
              }`}
            >
              Admission
            </Link>
          </li>

          <li>
            <Link
              to='/contact'
              aria-label='contact '
              title='contact'
              className='btn-primary hover-up-2'
            >
              Contact Us
            </Link>
          </li>
        </ul>
        <div className='lg:hidden'>
          <button
            aria-label='Open Menu'
            title='Open Menu'
            className='p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-deep-purple-50 focus:bg-deep-purple-50'
            onClick={() => setIsMenuOpen(true)}
          >
            <svg className='w-5 text-gray-600' viewBox='0 0 24 24'>
              <path
                fill='currentColor'
                d='M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z'
              />
              <path
                fill='currentColor'
                d='M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z'
              />
              <path
                fill='currentColor'
                d='M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z'
              />
            </svg>
          </button>
          {isMenuOpen && (
            <div className='absolute top-0 left-0 w-full z-10'>
              <div className='p-5 bg-white border rounded shadow-sm'>
                <div className='flex items-center justify-between mb-4'>
                  <div>
                    <Link
                      to='/'
                      aria-label=' iTesser-act'
                      title=' iTesser-act'
                      className='inline-flex items-center'
                    >
                      <img className='w-48' src={logo} alt='logo' />
                    </Link>
                  </div>
                  <div>
                    <button
                      aria-label='Close Menu'
                      title='Close Menu'
                      className='p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline'
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <svg className='w-5 text-gray-600' viewBox='0 0 24 24'>
                        <path
                          fill='currentColor'
                          d='M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z'
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <nav>
                  <ul className='space-y-4 text-center'>
                    <li>
                      <Link
                        to='/'
                        aria-label='Home'
                        title='Home'
                        className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                          isActive('/')
                            ? 'primary-color font-bold'
                            : 'text-gray-700 hover:primary-color'
                        }`}
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link
                        to='/about'
                        aria-label='About Us'
                        title='About Us'
                        className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                          isActive('/about')
                            ? 'primary-color font-bold'
                            : 'text-gray-700 hover:primary-color'
                        }`}
                      >
                        About Us
                      </Link>
                    </li>

                    <li>
                      <Link
                        to='/courses'
                        aria-label='Courses'
                        title='Courses'
                        className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                          isActive('/courses')
                            ? 'primary-color'
                            : 'text-gray-700 hover:primary-color'
                        }`}
                      >
                        Courses
                      </Link>
                    </li>
                    <li>
                      <Link
                        to='/gallery'
                        aria-label='Our Gallery'
                        title='Our Gallery'
                        className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                          isActive('/gallery')
                            ? 'primary-color'
                            : 'text-gray-700 hover:primary-color'
                        }`}
                      >
                        Our Gallery
                      </Link>
                    </li>
                    <li>
                      <Link
                        to='/team'
                        aria-label='Our Team'
                        title='Our Team'
                        className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                          isActive('/team')
                            ? 'primary-color'
                            : 'text-gray-700 hover:primary-color'
                        }`}
                      >
                        Our Team
                      </Link>
                    </li>
                    <li>
                      <Link
                        to='/admission'
                        aria-label='Admission'
                        title='Admission'
                        className={`font-semibold tracking-wide text-[15px] transition-colors duration-200 ${
                          isActive('/admission')
                            ? 'primary-color'
                            : 'text-gray-700 hover:primary-color'
                        }`}
                      >
                        Admission
                      </Link>
                    </li>
                    <li>
                      <Link
                        to='/contact'
                        aria-label='contact '
                        title='contact'
                        className='btn-primary hover-up-2'
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
